import { reactive, watch, ref, nextTick } from 'vue';
import axios from 'axios';

// Cargar el carrito desde localStorage
const loadCartFromLocalStorage = () => {
  const cartData = localStorage.getItem('cart');
  return cartData ? JSON.parse(cartData) : [];
};

// --- SINGLETON STATE ---
const state = reactive({
  cart: loadCartFromLocalStorage(),
});
const multicombos = ref([]);

// Sincronizar con localStorage
watch(
  () => state.cart,
  (newCart) => {
    localStorage.setItem('cart', JSON.stringify(newCart));
  },
  { deep: true }
);


// ----------------------------------------------------------
// NORMAL addToCart
// ----------------------------------------------------------


const addToCart = (product) => {
  console.group('🧩 addToCart()');
  console.log('Producto recibido:', product);
  console.log('price FINAL:', product?.price);
  console.groupEnd();
const basePrice = Number(product.price);
const promoPercent = Number(product.promo_price ?? 0);

const finalPrice =
  product.id_promocion && promoPercent > 0
    ? Number((basePrice - basePrice * (promoPercent / 100)).toFixed(2))
    : basePrice;
  const sku = product.sku ?? String(product.producto_id ?? product.id);

  const existing = state.cart.find(item => item.sku === sku);

  // 🔥 CORRECCIÓN: Detectar si es promo real basándonos en ID y porcentaje, no en la bandera 'promoUnico' que viene mal
  const isPromo = !!(product.id_promocion && promoPercent > 0);

  //  LÍMITE PROMO
 // BLOQUEO PARA PROMOCIONES (Línea 48)
  if (existing && isPromo) {
    if (existing.quantity >= 5) {
      alert('Máximo 5 unidades por producto en promoción.');
      return;
    }
    // ...
  }

  // BLOQUEO PARA PRODUCTOS NORMALES (Línea 58)
  if (existing) {
    if (existing.quantity < 40) {
      existing.quantity += 1;
    } else {
      alert('Solo puedes agregar hasta 40 unidades de este producto.');
    }
    return;
  }

  // 🆕 PRODUCTO NUEVO
  state.cart.push({
    ...product,

    // 🔒 PRECIO FINAL (NO SE TOCA)
    price: finalPrice,
    promoUnico: isPromo,
    quantity: 1,
    sku,
    linea_prod_id: product.linea_prod_id ?? null,
    pround: product.pround ?? 'CJA',

    iva: Number(product.iva16 ?? product.iva ?? 0),
    ieps: Number(product.ieps ?? 0),

  });

  validateMultiCombos();
  if (navigator.vibrate) navigator.vibrate(50);
};




// ----------------------------------------------------------
const lastUpdated = ref(Date.now());

const resetState = async () => {
  state.cart = [];
  lastUpdated.value = Date.now();
  localStorage.removeItem('cart');
  localStorage.removeItem('checkoutTotal');
  await nextTick();
};

// ----------------------------------------------------------
// PROMOCIONES addToCart2
// ----------------------------------------------------------
const addToCart2 = async (product) => {
  try {
    const { data } = await axios.get(
      `https://mvexpress.mx/api/promotion/${product.id}`
    );

    const promo = data?.[0];
    if (!promo) return;


    console.log('promo tiene esto ',promo)
          
      addToCart({
        // 🔑 Identidad real del producto
        id: promo.id_producto,
        sku: promo.PRODUC_CODIGO_K,

        // 🔥 PRECIO FINAL YA CALCULADO (NO SE TOCA)
        price: Number(promo.precio_con_descuento),

        // 🔒 PRECIO ORIGINAL SOLO INFORMATIVO
        precio_lista: Number(promo.precio_mostrador ?? promo.precio_lista ?? promo.price),

        quantity: 1,

        pround: promo.pround ?? 'CJA',
        linea_prod_id: promo.linea_prod_id,

        // 🔥 PROMO (SOLO METADATA)
        id_promocion: promo.id_promocion,
        promo_percent: promo.promo_price,   // 10
        promoUnico: true,

        // impuestos
        iva: Number(promo.iva16 ?? promo.iva ?? 0),
        ieps: Number(promo.ieps ?? 0),
      });


  } catch (err) {
    console.error(err);
    alert("No se pudo agregar la promoción");
  }
};



// ----------------------------------------------------------
// 🔥🔥🔥 addGiftToCart (PROMOCIÓN CON REGALO BLOQUEADA) 🔥🔥🔥
// ----------------------------------------------------------
const addGiftToCart = async (item) => {
  try {
    console.log("🔹 Agregando promoción al carrito:", item);

    // 1️⃣ Obtener datos de la promoción
    const { data: promo } = await axios.get(`https://mvexpress.mx/api/promotion2/${item.id}`);
    if (!promo) return alert("No se encontraron detalles de la promoción.");

    const cantidad = promo.cantidad || 1;  // principal debe quedar fijo en esta cantidad
    const comboId = `combo-${promo.id}`;

    // 2️⃣ Cargar productos del combo
    const { data: mainData } = await axios.get(`https://mvexpress.mx/api/get-sku/${promo.sku_producto}`);
    const mainProduct = mainData[0];

    const { data: giftData } = await axios.get(`https://mvexpress.mx/api/get-sku/${promo.sku_regalo}`);
    const giftProduct = giftData[0];

    if (!mainProduct || !giftProduct) {
      return alert("No se pudieron obtener los productos.");
    }

    // 3️⃣ Buscar existentes
    const existingMain = state.cart.find(
      p => p.sku === mainProduct.sku && p.comboId === comboId && p.isMain
    );

    const existingGift = state.cart.find(
      p => p.sku === giftProduct.sku && p.comboId === comboId && p.isGift
    );

    // ------------------------------
    // 🔹 4️⃣ PRODUCTO PRINCIPAL (NO SE AUMENTA)
    // ------------------------------
    if (!existingMain) {
      // 🔥 CORRECCIÓN: Validación robusta del precio para evitar NaN o 0
      // A veces 'get-sku' devuelve 'precio_lista' o 'precio_1' en lugar de 'price'
      const precioBase = Number(mainProduct.precio_con_descuento) || 
                         Number(mainProduct.price) || 
                         Number(mainProduct.precio_lista) || 
                         Number(mainProduct.precio_mostrador) || 
                         0;

      // Se agrega solo una vez con la cantidad de la promo (5,10,...)
      state.cart.push({
        ...mainProduct,
        quantity: cantidad,
        comboId,
        isMain: true,
        promoUnico: true,
        price: precioBase
      });
    }
    // ❗ Si ya existe, NO aumentar más
    else {
      existingMain.quantity = cantidad; // siempre fijo
    }

    // ------------------------------
    // 🔹 5️⃣ PRODUCTO REGALO (SUMA 1 POR CLICK)
    // ------------------------------
    if (existingGift) {
      existingGift.quantity += 1; // ahora sí suma correcto
    } else {
      state.cart.push({
        ...giftProduct,
        quantity: 1,
        comboId,
        isGift: true,
        price: 0,
        nombre: `${giftProduct.nombre} 🎁`
      });
    }

    // Guardar cambios
    localStorage.setItem("cart", JSON.stringify(state.cart));

    alert(`Promo "${promo.nombre}" agregada correctamente.`);

  } catch (error) {
    console.error("❌ Error al agregar promoción:", error);
    alert("No se pudo agregar la promoción.");
  }
};

// ----------------------------------------------------------
// ELIMINAR
// ----------------------------------------------------------
const removeFromCart = (itemOrIndex) => {
  let index = itemOrIndex;

  if (typeof itemOrIndex === 'object' && itemOrIndex !== null) {
    index = state.cart.findIndex(
      (p) => p.sku === itemOrIndex.sku && p.id === itemOrIndex.id
    );
  }

  if (index !== -1 && index < state.cart.length) {
    state.cart.splice(index, 1);
    validateMultiCombos();
  }
};

const removeComboFromCart = (comboId) => {

  state.cart = state.cart.filter(p => p.comboId !== comboId);
  validateMultiCombos();

};

// ----------------------------------------------------------
// BLOQUEAR + / - PARA PROMOCIONES 🔒
// ----------------------------------------------------------
const increaseQuantity = (item) => {
  console.log("➕ increaseQuantity", item.sku);

  if (item.isLocked) {
    alert("Esta promoción no permite modificar cantidades.");
    return;
  }

  const existingProduct = state.cart.find(
    (product) => product.sku === item.sku && product.id === item.id
  );

  if (!existingProduct) return;

  if (existingProduct.quantity >= 40) {
    alert("Solo puedes agregar hasta 40 unidades.");
    return;
  }

  existingProduct.quantity++;
};



const decreaseQuantity = (item) => {
  if (item.isLocked) return;

  const index = state.cart.findIndex(
    (product) => product.sku === item.sku && product.id === item.id
  );

  if (index === -1) return;

  if (state.cart[index].quantity > 1) {
    state.cart[index].quantity--;
  } else {
    state.cart.splice(index, 1);
  }

  validateMultiCombos();
};
// ----------------------------------------------------------
const getCartTotal = () => {
  return state.cart.reduce((total, item) => {
    if (item.sku && item.sku.startsWith('PP')) return total;
    const price = item.precio_con_descuento || item.price;
    return total + price * item.quantity;
  }, 0).toFixed(2);
};

const getTotalCajas = () => {
  return state.cart.reduce((total, item) => total + item.quantity, 0);
};

const getProductQuantity = (product) => {
  const existing = state.cart.find(
    (item) => item.sku === product.sku && item.id === product.id
  );
  return existing ? existing.quantity : 0;
};

// ----------------------------------------------------------
const checkout = () => {
  const total = state.cart.reduce((acc, item) => {
    if (item.sku?.startsWith('PP')) return acc;
    const price = item.precio_con_descuento || item.price;
    return acc + price * item.quantity;
  }, 0);

  const rounded = parseFloat(total.toFixed(2));
  localStorage.setItem('checkoutTotal', rounded);
  alert(`Total a pagar: $${rounded}`);
  return rounded;
};

// =========================
// VALIDAR MULTICOMBOS
// =========================
const validateMultiCombos = () => {
  const comboDefs = multicombos.value;

  if (!Array.isArray(comboDefs)) return;

  comboDefs.forEach(combo => {
    const comboId = `multicombo-${combo.id}`;

    const requiredItems = combo.items.filter(i => i.tipo === "PRINCIPAL");
    const giftItems = combo.items.filter(i => i.tipo === "REGALO");

    // ============================================================
    // ✔ 1) APLICAR PRECIO FIJO
    // ============================================================
    requiredItems.forEach(req => {
      state.cart.forEach(cartItem => {
        if (cartItem.id === req.producto_id) {
          if (req.precio_fijo) {
            cartItem.price = Number(req.precio_fijo);
            cartItem.comboId = comboId;
            cartItem.isComboItem = true;
          }
        }
      });
    });

    // ============================================================
    // ✔ 2) CONTAR PRINCIPALES
    // ============================================================
    let totalPrincipales = 0;

    requiredItems.forEach(req => {
      state.cart.forEach(cartItem => {
        if (cartItem.id === req.producto_id) {
          totalPrincipales += cartItem.quantity;
        }
      });
    });

    const cumple = totalPrincipales >= (requiredItems[0]?.cantidad || 0);

    // ============================================================
    // ✔ 3) SI ES REGALO MANUAL (addGiftToCart) → NO tocarlo
    // ============================================================
    const hasManualGift = state.cart.some(i =>
      i.comboId === comboId && i.isGiftFromPromotion
    );

    if (hasManualGift) {
      return; // ⛔ No agregar ni quitar regalos automáticos
    }

    // ============================================================
    // ✔ 4) MANEJO DE REGALOS AUTOMÁTICOS
    // ============================================================
    if (cumple) {
      giftItems.forEach(gift => {
        const existsGift = state.cart.find(p =>
          p.comboId === comboId &&
          p.isGift === true &&
          p.sku === gift.producto.sku
        );

        if (!existsGift) {
          state.cart.push({
            ...gift.producto,
            sku: gift.producto.sku,
            producto_id: gift.producto.id,
            comboId,
            isGift: true,
            price: 0,
            quantity: 1,
            nombre: gift.producto.nombre + " 🎁"
          });
        }
      });

    } else {
      // ❌ Si ya no cumple, quitar regalos automáticos
      state.cart = state.cart.filter(item =>
        !(item.comboId === comboId && item.isGift && !item.isGiftFromPromotion)
      );
    }
  });

  // ============================================================
  // ✔ 5) ORDENAR REGALOS AL FINAL DEL CARRITO
  // ============================================================
  state.cart.sort((a, b) => {
    if (a.isGift && !b.isGift) return 1;
    if (!a.isGift && b.isGift) return -1;
    return 0;
  });

  localStorage.setItem("cart", JSON.stringify(state.cart));
};




//CARGAR MULTICOMBOS
// =========================
const loadMulticombos = async () => {
  try {
    const token = localStorage.getItem("token"); // ← obtiene el token

    const res = await axios.get(
      "https://mvexpress.mx/api/promotions/promos/multicombo",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    // 🔒 aseguramos que sea array
    multicombos.value = Array.isArray(res.data.combos)
      ? res.data.combos
      : [];

    console.log("Multicombos cargados:", multicombos.value);

  } catch (err) {
    console.error("❌ Error al cargar multicombos mamaste", err);
    multicombos.value = [];
  }
};


// =========================
// INICIALIZAR COMBOS
// =========================


// ----------------------------------------------------------
export function createCartStore() {
  return {
    state,
    resetState,
    lastUpdated,
    loadCartFromLocalStorage,
    addToCart,
    addToCart2,
    addGiftToCart,
    removeFromCart,
    removeComboFromCart,
    clearCart: resetState,
    getCartTotal,
    increaseQuantity,
    decreaseQuantity,
    getTotalCajas,
    getProductQuantity,
    checkout,
    validateMultiCombos,
    loadMulticombos

  };
}
